import { Children, isValidElement, ReactNode } from "react";

export const getInnerTextForAnalytics = (children: ReactNode): string => {
    if (typeof children === 'string') {
      return children;
    }
  
    if (!isValidElement(children) && !Array.isArray(children)) {
      return '';
    }
  
    if (Array.isArray(children)) {
      if (children.length === 0) {
        return '';
      }
      return getInnerTextForAnalytics(children[children.length - 1] as ReactNode); // Get the last child
    }
  
    /* eslint-disable @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access */
    const childArray = Children.toArray(children.props.children);
      
    if (childArray.length === 0) {
        return '';
    }
  
    return getInnerTextForAnalytics(childArray[childArray.length - 1] as ReactNode);
  }